import { useEffectAsync } from 'utils/useEffectAsync';
import useCleanup from 'utils/useCleanup';
import { fetchAndSetCompanySettingsData } from 'components/views/InvestorSettings/_helpers/investorSettings.resolvers';
import { $form, $view } from 'signals/global.signals';
import Company from 'components/views/InvestorSettings/_components/Company';
import withDismount from 'hocs/withDismount';

const InvestorSettings = () => {
  useEffectAsync(fetchAndSetCompanySettingsData);
  useCleanup([$view, $form]);

  return (
    <Company />
  );
};

export default withDismount(InvestorSettings);
